import React, { useEffect, useState } from 'react';

interface MobileBlockerProps {
  children: React.ReactNode;
}

const MobileBlocker: React.FC<MobileBlockerProps> = ({ children }) => {
  // Temporarily storing mobile state but not using it for blocking
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkIfMobile = () => {
      // Check if the device is a mobile phone (not including tablets)
      const mobileCheck = window.innerWidth < 768;
      setIsMobile(mobileCheck);
    };
    
    // Check on initial load
    checkIfMobile();
    
    // Check on window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  
  // TEMPORARILY DISABLED: Mobile blocking is disabled to test mobile-responsive layout
  if (false && isMobile) {
    return (
      <div className="min-h-screen bg-[#EFF0F5] flex flex-col items-center justify-center p-6 text-center">
        <div className="bg-white rounded-md shadow-sm p-8 max-w-md">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-16 w-16 mx-auto text-blue-500 mb-4" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
            />
          </svg>
          <h1 className="text-2xl font-semibold text-gray-800 mb-4">Lo sentimos</h1>
          <p className="text-gray-600 mb-6">
            Por el momento Atlas solo funciona desde una computadora o tablet.
          </p>
          <p className="text-gray-500 text-sm">
            Por favor, accede desde un dispositivo con una pantalla más grande para disfrutar de todas las funcionalidades.
          </p>
        </div>
      </div>
    );
  }
  
  return <>{children}</>;
};

export { MobileBlocker };
// NOTE: Mobile blocker is temporarily disabled for testing mobile UI
